export default [
  {
    path: '/asktaos',
    component: () => import('./profile'),
    children: [
      {
        path: 'sign',
        name: 'asktaos.sign',
        meta: {
          requiresAuth: true
        },
        component: () => import('./profile/sign')
      },
      {
        path: 'client',
        name: 'asktaos.client',
        meta: {
          requiresAuth: true
        },
        component: () => import('./profile/client')
      },
      {
        path: 'accounts',
        name: 'asktaos.accounts',
        meta: {
          requiresAuth: true
        },
        component: () => import('./profile/account')
      },
      {
        path: 'bind-account',
        name: 'asktaos.bind-account',
        meta: {
          requiresAuth: true
        },
        component: () => import('./profile/bind-account')
      },
      {
        path: 'register',
        name: 'asktaos.register',
        meta: {
          requiresAuth: true
        },
        component: () => import('./profile/register')
      },
      {
        path: 'rewards',
        name: 'asktaos.rewards',
        meta: {
          requiresAuth: true
        },
        component: () => import('./profile/rewards')
      },
      {
        path: 'cost_logs',
        name: 'asktaos.cost_logs',
        meta: {
          requiresAuth: true
        },
        component: () => import('./profile/cost_logs')
      },
    ]
  }
]
